module.exports = __webpack_public_path__ + "static/img/anxunMobile13.c2dfcbfe.png";